'use strict'

var decimalPointers = require('./decimalpointers'),
  digits = require('./digits'),
  getPixels = require('get-pixels'),
  Q = require('q'),
  clone = require('clone'),
  utils = require('./utils'),
  debugTiming = new utils.debugTiming('algorithm:timing'),
  debug = require('debug')('algorithm:general');

module.exports.setLogger = function(logger) {
  debugTiming = new utils.debugTiming('algorithm:timing', logger);
  debug = logger('algorithm:general');
  digits.setLogger(logger);
}

/*
  General error codes
    1: cannot load picture

Pointer algorithm Error codes:
    2: Value grow too much
    3: rounding error
    4: meter count is wrong
    5: value went backward

Digit Integer algorithm error codes:
    2: Value grow too much
    3: numbers not detected
    4: digits configuration error: previous value has more digits than expected
    5: value went backward

Digit decimals algorithm error codes:
    2: Value grow too much
    3: numbers not detected
    4: digits decimal integer incremented but digit integer has not (kamstrup)
*/


var analyzePointers = function(pixels, config) {
  return Q.Promise(function(resolve, reject) {
    var pixelsCopy = clone(pixels);
    debugTiming.logAndReset('clone took:');
    if (config.decimals && config.decimals.enabled == 1) {
      decimalPointers.analyzeImage(pixelsCopy, config, function(err, result) {
        debugTiming.logAndReset('decimalPointers.analyzeImage took:');
        // check if value is possible
        var maximumIncrement = utils.getMaximumPointerIncrement(config);
        if (!err && config.previousPointerValue !== 0) {
          if ((result.value - config.previousPointerValue) > maximumIncrement) {
            result.errorCode = 2;
            err = "value growth more than " + maximumIncrement + " value:" + result.value + " previousValue:" + config.previousPointerValue;
          } else if (result.value < config.previousPointerValue) {
            result.errorCode = 5;
            err = "value wen backward. value:" + result.value + " previousValue:" + config.previousPointerValue;
          }
        }
        //make sure that errorCode is set to 0 when there are no errors
        if (!result.errorCode) {
          result.errorCode = 0;
        }
        if (err) {
          result.errObj = err;
        }
        resolve({pixels:pixels, config:config, result:{pointers:result}})
      });
    } else { // decimals not turned on
      resolve({pixels:pixels, config:config, result:{pointers:null}})
    }
  });
}

var analyzeDigits = function(obj) {
  return Q.Promise(function(resolve, reject) {
    if (obj.config.digits && obj.config.digits.enabled == 1 && (obj.config.analyzeDigits || obj.config.forceAnalyzeDigits)) {
      var pixelsCopy = clone(obj.pixels);
      debugTiming.logAndReset('clone in analyzeDigits took:');
      digits.analyzeImage(pixelsCopy, obj.config, function(err, result) {
        debugTiming.logAndReset('digits.analyzeImage took');
        obj.result.digits = result;
        resolve(obj);
      }, obj.config.digits.debugImage);
    } else {
      resolve(obj);
    }
  });
}

exports.analyzeDigits = analyzeDigits;

var analyzePixels = function(pixels, config, cb) {
  config = utils.adjustCoordinates(clone(config));
  debugTiming.start();
  analyzePointers(pixels, config)
    .then(analyzeDigits)
    .fail(function (error) {
      //in case of failure, just return empty object
      cb(null, {pointers:null, digits:null}, pixels);
    })
    .done(function (obj) {
      cb(null, obj.result, obj.pixels);
    });
}

/*
img    : url is the path to the file. It can be a relative path, an http url, a data url, or an in-memory Buffer.
config : {
      previousPointerValue: <previous pointer value>,
      previousDigitsValue: <previous digits value>,
      decimals: settings.decimals,
      digits: settings.digits,
      offset: settings.offset,
      maximumIncrement: settings.maximumIncrement,
      analyzeDigits:flag to forse digits detection off -> used to restrict that digits are not analyzed in every round,
    }
*/
exports.analyzeImage = function(img, config, cb) {
  debugTiming.start();
  getPixels(img, function(err, pixels) {
    debugTiming.logAndReset('getPixels took:');
    if (err) {
      var res = {errorCode:1}
      cb("Error while getting image:" + img + " " + err, res);
    } else {
      analyzePixels(pixels, config, cb);
    }
  })
}

exports.analyzePixels = analyzePixels;



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/index.js
// module id = 846
// module chunks = 0